// extracted by mini-css-extract-plugin
export var label = "_ql-0";
export var link = "_ql-1";